import React, { useState } from 'react';
import { MetaRow } from 'containers/Manage-Questionnaire/styled-components';
import {
  Intent,
  Button,
  InputGroup,
  FormGroup,
  Switch,
  Tooltip,
  Icon,
} from '@blueprintjs/core';
import FormSelectGroup from 'components/forms/components/form-select-group';
import { IconNames } from '@blueprintjs/icons';
import colors from 'utils/colors';
import { FlexRow } from 'components/styled-components';

const TypeEditor = ({
  update,
  fetch,
  content,
  toggleEdit,
  id,
  name,
  mandatory,
  departments,
  origDepartments,
}) => {
  const [value, setValue] = useState(name);
  const [_mandatory, setMandatory] = useState(mandatory);
  const [submitting, toggleSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [isError, toggleError] = useState(false);
  const [qtDepartments, setQtDepartments] = useState(origDepartments);

  const reset = () => {
    toggleEdit(false);
    setValue(name);
  };

  const clearError = () => {
    setError('');
    toggleError(false);
  };

  const handleValueChange = e => {
    const { value } = e.target;
    if (value.length >= 2) {
      clearError();
    }
    setValue(value);
  };

  const handleDepartmentChange = (key, selected) => {
	  setQtDepartments(selected.map(dpt => dpt.departmentID));
  }

  const handleSubmit = () => {
    if (value.length >= 2) {
      clearError();
      toggleSubmitting(true);
      // if the value is the same as the original, send it as an empty string to avoid versioning the question type
      //const _value = value === name ? '' : value; get out of here, stupid way of doing this
	  const _value = value;
	  const typeDepartments = qtDepartments;
      update(id, _value, typeDepartments, _mandatory)
        .then(() => {
          toggleSubmitting(false);
          reset();
          fetch();
        })
        .catch(err => {
          toggleError(true);
          setError(err.response.data.message);
          toggleSubmitting(false);
        });
    } else {
      toggleError(true);
      setError(`${content} must be at least 2 characters.`);
    }
  };

  const diffArr = (arr1, arr2) => arr1.filter(x => !arr2.includes(x)).concat(arr2.filter(x => !arr1.includes(x)));

  const unchanged = () => {
	return value === name
		&& diffArr(origDepartments, qtDepartments).length === 0
		&& _mandatory == mandatory;
  };
  
  return (
    <MetaRow align={'baseline'} style={{"flexDirection": "column", "border": "1px solid #AAAAAA"}}>
      <div>
	    <FormGroup label="Name" labelFor="question-type-name-input">
			<InputGroup
				id="question-type-name-input"
				value={value}
				onChange={handleValueChange}
				intent={isError ? Intent.DANGER : Intent.NONE}
				large
				style={{ minWidth: 300 }}
			/>
		</FormGroup>
		<FormSelectGroup
			label=" Department"
			name="department"
			asyncOptions={departments}
			labelKey="departmentName"
			valueKey="departmentID"
			value={departments.filter(dpt => qtDepartments.includes(dpt.departmentID))}
			onChange={handleDepartmentChange}
			noOptionsMessage="No departments were found. Create a new one in the Admin Tools"
			isClearable={true}
			multi
		/>
        <FlexRow align={'baseline'} justify={'flex-start'}>
          <Switch
            checked={_mandatory}
            onChange={() => setMandatory(!_mandatory)}
            label="Mandatory:"
            alignIndicator="right"
            innerLabel="No"
            innerLabelChecked="Yes"
          />
          <Tooltip content="If a question type is mandatory, that section of a questionnaire cannot be bypassed via opt-out">
            <Icon icon={IconNames.INFO_SIGN} style={{ marginLeft: 5 }} />
          </Tooltip>
        </FlexRow>
      </div>

      <div>
        <Button onClick={reset} minimal text="cancel" />
        <Button
          intent={Intent.PRIMARY}
          text="SAVE"
          disabled={submitting || unchanged()}
          onClick={handleSubmit}
          loading={submitting}
        />
      </div>

      <div style={{ color: colors.red, marginLeft: 10 }}>{error}</div>
    </MetaRow>
  );
};

export default TypeEditor;
